// extracted by mini-css-extract-plugin
export default {"nav":"navHeader_nav__HPOza","navImage":"navHeader_navImage__HF5+2","userName":"navHeader_userName__KykUW","menuButton":"navHeader_menuButton__Y0AK7"};